import { defineStore } from "pinia";
import { updateFilters, getFilters } from "@components/helper/localStorageHelper";

import { ref } from "vue";

export const useFiltersStore = defineStore("filters", () => {
  const filters = ref([]);

  const setFilters = ({ key, filters: newFiltersValue }) => {
    filters.value = newFiltersValue;
    updateFilters(key, newFiltersValue);
  };

  const loadFilters = (key) => {
    const savedFilters = getFilters(key);
    filters.value = Array.isArray(savedFilters) ? savedFilters : [];
  };

  /** Clear in-memory filters only — does not touch localStorage / filtersByAccess. */
  const resetFilters = () => {
    filters.value = [];
  };

  return {
    filters,
    setFilters,
    loadFilters,
    resetFilters,
  };
});
